export const DOMAIN_SCC = '//sccapi.cekid.com/'
export const DOMAIN_HZW = 'https://svsesapi.haiziwang.com/'
// export const PREFIX_SCC_API = `${DOMAIN_SCC}scc-api/`
export const PREFIX_SCC_API = '//sccapi.cekid.com/scc-api/'

export const PREFIX_SCC_WEB = '//sccweb.cekid.com/scc-web/'

// export const PREFIX_SCB = '//scbapi.czj100.com/scb-api/'
export const PREFIX_SCB_API = '//scbapi.cekid.com/scb-api/'

// export const PREFIX_SORDER = '//sorderapi.czj100.com/sorder-api/'
export const PREFIX_SORDER = '//sorderapi.cekid.com/sorder-api/'
export const PREFIX_KS_SORDER = `${PREFIX_SORDER}KSOrder/`

// export const PREFIX_STRADE_API = '//stradeapi.czj100.com/strade-api/strade/'
export const PREFIX_STRADE_API = '//stradeapi.cekid.com/strade-api/'
export const PREFIX_STRADE = `${PREFIX_STRADE_API}strade/`

// export const PREFIX_SCATERP_API = '//scaterpapi.czj100.com/scaterp-api/'
export const PREFIX_SCATERP_API = '//scaterpapi.cekid.com/scaterp-api/'
export const PREFIX_SCATERP = `${PREFIX_SCATERP_API}caterp/`

// export const PREFIX_SOPERATION_API = '//soperationapi.czj100.com/soperation-api'
export const PREFIX_SOPERATION_API = '//soperationapi.cekid.com/soperation-api/'

export const PREFIX_SCOUPON_API = '//scouponapi.cekid.com/scoupon-api/'

export const PREFIX_SPROMOTION_API = '//spromotionapi.cekid.com/spromotion-api/'

// export const PREFIX_SVSACTIVITY_API = '//svsactivity.haiziwang.com/svshd-web/'
export const PREFIX_SVSACTIVITY_API = '//svsactivity.cekid.com/svshd-web/'

// export const PREFIX_BIGYUER_API = '//api.czj100.com/big.yuer/'
// export const PREFIX_BIGYUER_API = '//czjcapi.cekid.com/big.yuer/'//error czjcapi 是java中间层接口
export const PREFIX_BIGYUER_API = '//czjapi.cekid.com/big.yuer/' // czjapi 是php接口

// export const PREFIX_BANK_API = '//api.czj100.com/bank/'
export const PREFIX_BANK_API = '//czjapi.cekid.com/bank/'

export const PREFIX_CZJC_API = '//czjcapi.czj100.com/api-c/'
// export const PREFIX_CZJC_API = '/api-c/'

export const PREFIX_CZJCAPI_API = '//czjcapi.cekid.com/api-c/'

export const PREFIX_SUPLOAD_API = '//suploadapi.cekid.com/supload-api/'
